import React from 'react';
import { Modal as ContentModal } from 'react-bootstrap';
import PropTypes from 'prop-types';

import Button from '../Button';

const Modal = ({
  ctaFunction,
  onHide,
  onExit,
  children,
  icon,
  title,
  isOpen,
  onTopCancelClick = null,
  loading = false,
  variant = 'primary',
  size = undefined,
  cancelButton = false,
  ctaButton = false,
  ctaText = 'Confirm',
  backdrop = true,
}) => {
  const validFunction = typeof ctaFunction === 'function';

  return (
    <ContentModal show={isOpen} size={size} onHide={onHide} onExit={onExit} backdrop={backdrop}>
      <ContentModal.Header closeButton={false} bsPrefix='modal-header d-flex align-items-start text-break'>
        <ContentModal.Title>
          {icon && <span className={`fas ${icon ? `fa-${icon}` : ''} text-${variant} me-3`} aria-hidden='true' />}
          {title && <span className='me-3' aria-label='Modal Title'>{title}</span>}
          <Button ghost className='modal-close-icon p-0' ariaLabel='Close' onClick={onTopCancelClick || onHide}>
            <span className='fas fa-xmark text-dark pointer' />
          </Button>
        </ContentModal.Title>
      </ContentModal.Header>
      <ContentModal.Body>{children}</ContentModal.Body>
      {(cancelButton || validFunction || ctaButton) && (
        <ContentModal.Footer>
          <div className='d-flex justify-content-end align-items-center'>
            {cancelButton && <Button
              ghost
              variant={variant}
              className='me-3 text-muted'
              onClick={onHide}>
              Cancel
            </Button>}
            {ctaButton && (
              <Button
                variant={variant}
                loading={loading}
                onClick={() => {
                  if (validFunction) {
                    ctaFunction();
                  }
                }}
              >
                {ctaText}
              </Button>
            )}
          </div>
        </ContentModal.Footer>
      )}
    </ContentModal>
  );
};

Modal.propTypes = {
  ctaFunction: PropTypes.func,
  onHide: PropTypes.func,
  onExit: PropTypes.func,
  children: PropTypes.any,
  icon: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.any,
  loading: PropTypes.bool,
  variant: PropTypes.string,
  size: PropTypes.string,
  cancelButton: PropTypes.bool,
  ctaButton: PropTypes.bool,
  ctaText: PropTypes.string,
  backdrop: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
  ]),
  onTopCancelClick: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.oneOf([null]),
  ]),
};

export default Modal;
